import { axiosCms } from 'Axios.js';
import { authToken } from '../utility';
import * as actionTypes from './actionTypes';

const fetchUsersStart = () => ({ type: actionTypes.FETCH_USERS_START });
const fetchUsersEnd = users => ({ type: actionTypes.FETCH_USERS_END, users });
// const unverifyUserStart = () => ({ type: actionTypes.UNVERIFY_USERS_START })
// const unverifyUserEnd = () => ({ type: actionTypes.UNVERIFY_USERS_END })

export const fetchUsers = (option = 'default') => {
  return dispatch => {
    dispatch(fetchUsersStart());

    axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());
    return axiosCms
      .get('/users')
      .then(resp => {
        const { data } = resp;
        dispatch(fetchUsersEnd(data.users));
        if (option === 'response_data') return data.users;
        else return 'completed';
      })
      .catch(err => {
        console.error(`#fetchUsers`, err);
        return Promise.reject(err);
      });
  };
};

// export const unVerifyUser = id => dispatch => {
//     dispatch(unverifyUserStart())

//     axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken())
//     return axiosCms.patch('/phone_numbers/' + id + '/unverify')
//         .then(resp => {
//             dispatch(unverifyUserEnd())
//             // pass flag to return response data instead of "completed" string
//             return dispatch(fetchUsers("response_data"))
//         })
//         .catch(err => {
//             console.error(`#unVerifyUser`, err)
//             return Promise.reject(err)
//         })
// }



// WEBPACK FOOTER //
// ./src/store/actions/user.js